import * as React from 'react';
import * as classNames from 'classnames';

interface IconProps {
	name: string;
	className?: string;
	fixedWidth?: boolean;
	size?: 'lg' | '2x' | '3x' | '4x' | '5x';
}

export default class Icon extends React.Component<IconProps, {}> {

	public render() {
		const className = classNames('fa', `fa-${this.props.name}`, this.props.className, {
			'fa-fw': this.props.fixedWidth,
			'fa-lg': this.props.size === 'lg',
			'fa-2x': this.props.size === '2x',
			'fa-3x': this.props.size === '3x',
			'fa-4x': this.props.size === '4x',
			'fa-5x': this.props.size === '5x',
		});
		return <i className={className} aria-hidden />;
	}

}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./ts/components/util/widgets/Icon.tsx